import { useMutation, useQueryClient } from '@tanstack/react-query';
import { meetingCommentApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export interface IMeetingCommentScope {
  jobId: number;
  meetingId: string;
  topicId: string;
  issueId: string;
}

export function useCreateMeetingComment(scope: IMeetingCommentScope) {
  const qc = useQueryClient();
  const { jobId, meetingId, topicId, issueId } = scope;
  return useMutation({
    mutationFn: (comment: string) =>
      meetingCommentApiClient.createComment(
        jobId,
        meetingId,
        topicId,
        issueId,
        {
          comment,
        },
      ),
    onSettled: () =>
      invalidateFor('meetingComment.save', qc, { jobId, meetingId, issueId }),
  });
}

export function useUpdateMeetingComment(scope: IMeetingCommentScope) {
  const qc = useQueryClient();
  const { jobId, meetingId, topicId, issueId } = scope;
  return useMutation({
    mutationFn: ({
      commentId,
      comment,
    }: {
      commentId: string;
      comment: string;
    }) =>
      meetingCommentApiClient.updateComment(
        jobId,
        meetingId,
        topicId,
        issueId,
        commentId,
        { comment },
      ),
    onSettled: () =>
      invalidateFor('meetingComment.save', qc, { jobId, meetingId, issueId }),
  });
}

export function useDeleteMeetingComment(scope: IMeetingCommentScope) {
  const qc = useQueryClient();
  const { jobId, meetingId, topicId, issueId } = scope;
  return useMutation({
    mutationFn: (commentId: string) =>
      meetingCommentApiClient.deleteComment(
        jobId,
        meetingId,
        topicId,
        issueId,
        commentId,
      ),
    onSettled: () =>
      invalidateFor('meetingComment.save', qc, { jobId, meetingId, issueId }),
  });
}
